module.exports = __webpack_public_path__ + "img/prev_porte.7c1fee9c.png";